import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
function getListItemButtonUtilityClass(slot) {
  return generateUtilityClass("MuiListItemButton", slot);
}
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
const listItemButtonClasses$1 = listItemButtonClasses;
export {
  listItemButtonClasses$1 as default,
  getListItemButtonUtilityClass
};
//# sourceMappingURL=listItemButtonClasses.es.js.map
